import { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
    const { token } = useContext(AuthContext);

    return token ? children : <Navigate to="/" />;
};

export default PrivateRoute;